import React from 'react';
import { Link } from "react-router-dom";
import ReactGA from 'react-ga';

function getRandom(arr, n) {
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    if (n > len)
        throw new RangeError("getRandom: more elements taken than available");
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
}

class ListOfMaps extends React.Component{
    constructor(props){
        super(props);
        const randomFive = getRandom(this.props.tags, 5);
        this.state = {
            selectedTags: randomFive,
            allCards: this.props.tags
        }
        console.log(this.props.tags, randomFive);
        this.onClickAction = this.onClickAction.bind(this);
        this.clearAllAction = this.clearAllAction.bind(this);
    }
    onClickAction(event){
        let indexOf = this.state.selectedTags.indexOf(event.target.value)
        let selectedTagsCloned = this.state.selectedTags.slice();
        if (indexOf ===-1){
            selectedTagsCloned.push(event.target.value);
            ReactGA.event({
                category: 'Filter',
                action: 'Added',
                label: event.target.value
            });
        }
        else{
            selectedTagsCloned.splice(indexOf,1);
            ReactGA.event({
                category: 'Filter',
                action: 'Removed',
                label: event.target.value
            });
        }
        this.setState({
            selectedTags: selectedTagsCloned
        });

    }

    clearAllAction(){
        this.setState({
            selectedTags: []
        });
        ReactGA.event({
            category: 'Filter',
            action: 'ClearAll'
        });
    }

    render(){
        return (
            <div className="container">
                <div className="shadow p-3 mb-5 bg-white rounded listOfMaps">
                <h2 >Entire catalogue of maps</h2>
                <hr />
                    <p className="h4">Filter by tags:</p>
                        <div className="tagsFilter">
                        {this.state.allCards.map((tag, k)=>{
                                if (this.state.selectedTags.includes(tag)) {
                                    return <button key={`tagFilterButton-${k}`} style={{ backgroundColor: this.props.tagToColor[tag], borderColor: this.props.tagToColor[tag] }} type="button" onClick={this.onClickAction} className="btn btn-dark mapTag" value={tag}>
                                        {tag}
                                    </button>
                                }
                                else {
                                    return <button type="button" onClick={this.onClickAction} className="btn btn-light mapTag" value={tag}>
                                        {tag}
                                    </button>
                                }
                            })}
                            
                        </div>
                    {this.state.selectedTags.length === 0 ? <div><button onClick={this.clearAllAction} style={{ marginLeft: "5px", marginBottom: "15px" }} type="button" disabled className="btn btn-outline-danger">Clear All</button></div>
                    :
                    <div><button onClick={this.clearAllAction} style={{ marginLeft: "5px", marginBottom: "15px" }} type="button" className="btn btn-outline-danger">Clear All</button></div>}
                    
                    <div className="USMaps MapsList">
                {this.props.urls["US"].map((x, k)=>{

                    // OPTIMISE THIS!!!

                    for(let i=0; i < x["tags"].length; i++){
                        // console.log(`${x["title"]} -> ${this.state.selectedTags.includes(x["tags"][i])}`);
                        if (this.state.selectedTags.includes(x["tags"][i])){
                            return(
                                <div>
                                    <div className="card mapCard">
                                        <div className="card-body">
                                            <Link className="mapCardTitle" to={x["url"]}><h5 className="card-title">{x["title"]}</h5></Link>
                                            
                                            <div className="mapCardTags">
                                            {x.tags.map((tag, i)=>(
                                                <span key={`mapCardTag-${i}`} className="badge badge-dark mapTag" style={{backgroundColor: this.props.tagToColor[tag]}}>{tag}</span>
                                            ))}
                                            
                                            {/* <Link className="btn btn-outline-secondary" to={x["url"]}>Go to map</Link> */}
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                            )
                        }
                    }
                    })}
                    </div>
                
                </div>
            </div>
            )
    }

}

export default ListOfMaps;